import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link, useLocation, useParams } from "react-router-dom";
import PharmacyProfileSidebar from "../Components/PharmacyProfileSidebar";
import { consultantmage, imgpharmacy, patientdetail } from "../Constant/Index";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
	getPharmacyappointmentsDetailsapi,
	getPharmacystaustupdatesapi,
} from "../network/Network";

const PrescriptionOrdersall = () => {
	const token = useSelector((state) => state?.Auth?.token);
	const [isStatusUpdated, setIsStatusUpdated] = useState(false);
	const [detailData, setDetailData] = React.useState(null);
	const [selectedOptions, setSelectedOptions] = useState({});
	const param = useParams();
	useEffect(() => {
		getPharmacyappointmentsDetailsapi(param?.Id, token).then((res) => {
			setDetailData(res?.data);
		});
	}, [param?.Id, token]);

	const handleSelect = (status, orderId) => {
		console.log(status, orderId, "asdasd");
		setSelectedOptions((prevState) => ({
			// ...prevState,
			status: status,
			id: orderId,
		}));
	};

	useEffect(() => {
		if (selectedOptions?.id && selectedOptions?.status) {
			getPharmacystaustupdatesapi(
				selectedOptions.id,
				selectedOptions.status,
				token,
			)
				.then((res) => {
					Swal.fire({
						position: "center",
						icon: "success",
						text: "Status has been updated",
						showConfirmButton: false,
						timer: 1500,
					});
					setIsStatusUpdated(true);
				})
				.catch((err) => {});
		}
	}, [selectedOptions]);

	console.log("Detail Data:", param?.Id, detailData);
	return (
		<>
			<Header />
			<PageHeader pagename="Physician Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PharmacyProfileSidebar />
						</div>

						<div className="col-lg-8">
							<div className="main-profile-content  radius-20 p-5">
								<div className="col-lg-7">
									<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
										<div className="edit-btn back">
											<Link to="/prescription-orders-all">
												<div className="nav-anchor">
													<i className="fa-solid fa-arrow-left"></i>
												</div>
											</Link>
										</div>
										<h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
											Prescription Orders
										</h5>
									</div>
								</div>
								<div className="main-profile-content  radius-20 p-5">
									<div className="row  border-bottom mb-4 pb-4 ">
										<div className="col-lg-12">
											<div className="d-flex align-items-center gap-5 wrapper-decomposition">
												<div className="d-flex gap-3 align-items-center">
													<img
														width={70}
														height={70}
														style={{ borderRadius: "50%", border: "none" }}
														src={
															detailData?.physician_detail
																?.physician_profile_image_url
														}
														className="img-fluid"
														alt=""
													/>
													<div>
														<h4 className="main-heading-font level-6 ">
															{detailData?.physician_detail?.physician_name}
														</h4>
														<h5 className="primary-medium-font level-8 extra-color-15">
															{
																detailData?.physician_detail
																	?.physician_degree_title
															}
														</h5>
													</div>
												</div>
												<div className="d-flex align-items-center gap-3">
													<div className="dropdown main-dropdown">
														<a
															className="click-dropdown  black-complete dropdown-toggle1"
															href="#"
															role="button"
															id="dropdownMenuLink"
															data-bs-toggle="dropdown"
															aria-expanded="false"
														>
															<span>
																{selectedOptions[
																	detailData?.order_detail?.order_id
																] || detailData?.order_detail?.order_status}
															</span>
															<i className="fa-solid fa-chevron-down"></i>
														</a>
														<ul
															className="dropdown-menu black-complete"
															aria-labelledby="dropdownMenuLink"
														>
															<li>
																<Link
																	className="dropdown-item level-8 black-complete"
																	to=""
																	onClick={() =>
																		handleSelect(
																			"pending",
																			detailData?.order_detail?.order_id,
																		)
																	}
																>
																	Pending
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item level-8 black-complete"
																	to=""
																	onClick={() =>
																		handleSelect(
																			"in-progress",
																			detailData?.order_detail?.order_id,
																		)
																	}
																>
																	In Progress
																</Link>
															</li>
															<li>
																<Link
																	className="dropdown-item level-8 black-complete"
																	to=""
																	onClick={() =>
																		handleSelect(
																			"completed",
																			detailData?.order_detail?.order_id,
																		)
																	}
																>
																	Completed
																</Link>
															</li>
														</ul>
													</div>
													<div className="d-flex align-items-center gap-1">
														<h4 className="main-heading-font level-6 ">
															Order Type:
														</h4>{" "}
														<h4 className="main-heading-font level-6 ">
															{detailData?.order_detail?.order_type ?? "N/A"}
														</h4>{" "}
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-lg-12">
											<h5 className="primary-medium-font level-8 extra-color-10 pe-5 line-height-normal">
												{detailData?.order_detail?.prescription_detail ?? "N/A"}
											</h5>
											<div className="mt-4 border-bottom mb-4 pb-4">
												{detailData?.order_detail?.prescription?.map(
													(item, index) => {
														return (
															<div
																className="d-flex align-items-center gap-3 mt-1"
																key={index}
															>
																<h4 className="extra-color-16 level-7">
																	{item?.prescription ?? "N/A"}
																</h4>
																<h4 className="extra-color-16 level-7">
																	- &nbsp;{item?.quantity ?? "N/A"}
																</h4>
															</div>
														);
													},
												)}
											</div>
											<div className="row">
												<div className="col-lg-12">
													<h4 className="main-heading-font level-6 ">
														Patient Detail
													</h4>
													<div className="d-flex align-items-start gap-3 mt-3">
														<img
															width={70}
															height={70}
															style={{ borderRadius: "50%", border: "none" }}
															src={
																detailData?.patient_detail?.profile_image_url
															}
															className="img-fluid mt-2 style-widht-wrapper"
															alt=""
														/>
														<div>
															<div className="row mt-3">
																<div className="col-lg-3 col-md-6 mb-2">
																	<h4 className="primary-medium-font level-8 extra-color-10">
																		First Name:{" "}
																		{detailData?.patient_detail?.first_name ??
																			"N/A"}
																	</h4>
																</div>
																<div className="col-lg-3 col-md-6 mb-2">
																	<h4 className="primary-medium-font level-8 extra-color-10">
																		Last Name:{" "}
																		{detailData?.patient_detail?.last_name ??
																			"N/A"}
																	</h4>
																</div>
																<div className="col-lg-12 col-md-6 mb-2">
																	<h4 className="primary-medium-font level-8 extra-color-10">
																		phone:
																		{detailData?.patient_detail?.phone ??
																			"N/A"}{" "}
																	</h4>
																</div>
																<div className="col-lg-4"></div>
																<div className="col-lg-12 col-md-6 mb-2">
																	<h4 className="primary-medium-font level-8 extra-color-10">
																		address:{" "}
																		{detailData?.patient_detail?.address ??
																			"N/A"}
																	</h4>
																</div>
															</div>
															<div className="row mt-2">
																<div className="col-lg-3 col-md-6 mb-2">
																	<h4 className="primary-medium-font level-8 extra-color-10">
																		City:{" "}
																		{detailData?.patient_detail?.city ?? "N/A"}
																	</h4>
																</div>
																<div className="col-lg-3 col-md-6 mb-2">
																	<h4 className="primary-medium-font level-8 extra-color-10">
																		State:{" "}
																		{detailData?.patient_detail?.state ?? "N/A"}
																	</h4>
																</div>
																<div className="col-lg-3 col-md-6 mb-2">
																	<h4 className="primary-medium-font level-8 extra-color-10">
																		Country:{" "}
																		{detailData?.patient_detail?.country ??
																			"N/A"}
																	</h4>
																</div>
																<div className="col-lg-3 col-md-6 mb-2">
																	<h4 className="primary-medium-font level-8 extra-color-10">
																		Zip Code/Postal Code:{" "}
																		{detailData?.patient_detail?.zip_code ??
																			"N/A"}
																	</h4>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PrescriptionOrdersall;
